import { UserInterface } from 'Interfaces'
import { Avatar } from 'antd'
import styles from './styles.module.scss'
import { UserOutlined } from '@ant-design/icons'
// helpers
import isEmpty from 'lodash/isEmpty'

const CommonCell = (value: string, record) => {
  const { key, ...rest } = record

  if (isEmpty(rest)) return <div className={styles.CommonCell} />

  const spanStyle = {
    display: 'inline-block',
    maxWidth: '95%',
    whiteSpace: 'nowrap' as 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }

  return <div className={styles.truncateCell} title={value ? value : undefined}>
    <span style={spanStyle}>
      {value ? value : 'N/A'}
    </span>
  </div>
}

export default CommonCell
